module.exports = __webpack_public_path__ + "img/kanette-du-mois-pictos.d3656fb0.png";